module.exports = __webpack_public_path__ + "img/insurance-providers.59f85ad.webp";